import { TaikyoNotificationForInput } from "src/api/data/TaikyoNotificationForInput";
import { RoomSb, TaikyoRiyuKb } from "src/extensions/utils/DefineTypes";
import { myPageStore } from "src/store/MyPageStore";
import { TaikyoNotificationEntity } from "~/api/data/TaikyoNotificationEntity";
/**
 * 退去申請入力画面ViewModel
 */
export class TaikyoNotificationViewModel {
    /**
     * @param model 退去通知情報
     * @param isMMA 個人情報ストア.MMA区分
     */
    constructor(model, taikyoForInput) {
        this.model = model;
        this.taikyoForInput = taikyoForInput;
    }
    model = new TaikyoNotificationEntity();
    taikyoForInput = new TaikyoNotificationForInput();
    /** MMA区分 */
    mmaKb = myPageStore.personal.mmaKb;
    get isMMA() {
        return this.mmaKb === 1;
    }
    getRoomType(taikyo) {
        return (myPageStore.personal.nyukyokeiyakuList.find(x => x.orgNyukyokeiyakuNo === taikyo.taikyoNo)?.roomSb ?? -1);
    }
    isParking(taikyo) {
        return this.getRoomType(taikyo) === RoomSb.Parking;
    }
    isRequiredTaikyoRiyu(taikyo) {
        return taikyo.taikyoRiyuKb === TaikyoRiyuKb.Other || taikyo.taikyoRiyuKb === TaikyoRiyuKb.DissatisfactionOrTrouble;
    }
    isDisableTaikyoRiyu(taikyo) {
        return taikyo.taikyoRiyuKb !== TaikyoRiyuKb.Other && taikyo.taikyoRiyuKb !== TaikyoRiyuKb.DissatisfactionOrTrouble;
    }
}
